// extracted by mini-css-extract-plugin
export default {"body":"body--4cb30f26","sidebar":"sidebar--92cdcd4d","content":"content--2d657e4b","copyright":"copyright--2aa57f2d","mask":"mask--3fa1e0fc","open":"open--76262ba2"};